import { makeStyles, withStyles } from "@material-ui/core/styles";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import TableRow from "@material-ui/core/TableRow";
import { TableCell } from "@material-ui/core";
import Colors from "../../../../utils/Colors";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    // width: theme.spacing(195),
  },
  padding: {
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(0),
  },
  reviewHeader: {
    borderRadius: "2px",
    textAlign: "center",
    borderWidth: "2px",
    borderColor: "gray",
  },
  reviewText: {
    borderRadius: "2px",
    borderWidth: "2px",
    borderColor: "gray",
    paddingInline: theme.spacing(2),
  },
  colorGrayLight: {
    backgroundColor: Colors.TICKET_GRAY_LIGHT,
  },
  root: {
    minWidth: 275,
    padding: 15,
    backgroundColor: Colors.TICKET_GREEN_LIGHT,
  },
}));

const Accordion = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: "rgba(0, 0, 0, .03)",
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    marginBottom: -1,
    minHeight: 56,
    "&$expanded": {
      minHeight: 56,
    },
  },
  content: {
    "&$expanded": {
      margin: "12px 0",
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);

const StyledHeadTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: Colors.WHITE,
    color: Colors.BLACK,
    fontWeight: "bold",
  },
  body: {
    borderColor: Colors.BLACK,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const COLORS_TC = {
  GREY: "#d3d3d3",
  LIGHT_GREEN_1: "#00ff00",
  LIGHT_GREEN_2: "#7fff00",
  YELLOW: "#ffff00",
  ORANGE: "#ff7f00",
  RED: "#ff0000",
  BLACK: "#000000",
};

export { useStyles, Accordion, AccordionSummary, AccordionDetails, StyledTableRow, StyledHeadTableCell, COLORS_TC };
